import ReportPlanner from "./ReportPlanner.vue";

export default [{
    "path": "/Audits/ReportPlanner",
    "component": ReportPlanner,
    "name": "Audits Schedule",
    "meta": {
        "app": "Audits",
        "storeData": ["Audits/CoreProcedures", "Audits/Procedures", "Audits/Cycles", "Audits/Reports"],

        "sideNav": true,
        "appSwitcher": false,
        "icon": "check-circle",
        "security": "Audits.Read",
        "name": "Audits Schedule",
        "sideNavSection": "Audits"
    },
    lock(user) {
        return [user?.Security?.Matrices?.Reviewer !== true, "Cannot view this area"]
    }
}];
